import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const RecommandedWrapper = styled.div`
  position: absolute;
  right: -10px;
  top: -10px;
  background-color: ${props => props.color ? props.color : '#008a16'};
  color: ${props => props.textColor ? props.textColor : 'white'};
  padding: 5px 10px;
`;

const RecommandedLabel = styled.span`
  font-weight: 700;
  font-size: 16px;
`;

const TriangleWrapper = styled.div`
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 10px;
  height: 10px;
  transform: translateY(100%);

`;

const Triangle = styled.div`
  position: absolute;
  top: 0px;right:0px;bottom:0px;left:0px;
  height : 0;
  width : 0;
  border-top : 10px solid ${props => props.color ? props.color : '#008a16'};
  border-right : 10px solid transparent;
`;

const TriangleMask = styled.div`
  position: absolute;
  top: 0px;right:0px;bottom:0px;left:0px;
  display : inline-block;
  height : 0;
  width : 0;
  opacity: 0.3;
  border-top : 10px solid black;
  border-right : 10px solid transparent;
`;

class RecommandedFlag extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    color: PropTypes.string,
    textColor: PropTypes.string,
  };

  render = () => {
    return (
      <RecommandedWrapper color={this.props.color} textColor={this.props.textColor}>
        <RecommandedLabel>{this.props.label}</RecommandedLabel>
        <TriangleWrapper>
          <Triangle color={this.props.color}></Triangle>
          <TriangleMask></TriangleMask>
        </TriangleWrapper>
      </RecommandedWrapper>
    );
  };
}

export default RecommandedFlag;
